export const listKeys = {
  list: () => ['LISTS'],
  detail: (id: number | string) => ['LIST', id],
};
